import React from 'react';
import {Input} from "../customer-data/input";
import CheckoutContext from "../../checkout-context";

class Payment extends React.Component {
    constructor(props) {
        super(props);
    }

    static contextType = CheckoutContext;

    render() {
        const {
            textsMapping,
            data: checkoutData
        } = this.context;

        const {directPaymentAvailable} = checkoutData;

        return (
            <section className="payment">
                <span className="payment-title">{textsMapping.paymentTitle}</span>

                <section className="checkout-section">
                    <Input
                        inputType="radio"
                        radioGroupName="paymentMethods"
                        directPaymentAvailable={directPaymentAvailable}
                        resourcedTexts={textsMapping}
                        radioButtons={[
                            {name: textsMapping.paymentMethodIdeal, value: "ideal"},
                            {name: textsMapping.paymentMethodInvoice, value: "invoice"}
                        ]}
                        path='selectedPaymentMethod'
                    />

                    {!directPaymentAvailable && (
                        <div className="payment-warning">
                            {textsMapping.paymentMethodInvoiceWarning}
                        </div>
                    )}
                </section>
            </section>
        )
    }
}

export default Payment;